import { Instagram, MessageCircle } from "lucide-react";
import { getWhatsAppLink, trackWhatsAppClick } from "@/lib/analytics";

export default function Footer({ whatsappNumber }) {
  const formattedNumber = "+90 534 332 31 11";

  return (
    <footer className="border-t border-white/5 py-14" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
          <div>
            <span className="text-lg font-bold tracking-tight text-white">
              Content House <span className="gold-text">TR</span>
            </span>
            <p className="mt-3 max-w-sm text-sm leading-relaxed text-slate-400">
              Türkiye'deki işletmelere Instagram ve Facebook reklam yönetimi hizmeti sunan performans pazarlama ajansı.
            </p>
          </div>

          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">Hizmetler</p>
            <ul className="mt-4 space-y-2 text-sm text-slate-400">
              <li><a href="#hizmetler" className="hover:text-gold-light transition-colors">Strateji</a></li>
              <li><a href="#hizmetler" className="hover:text-gold-light transition-colors">İçerik Üretimi</a></li>
              <li><a href="#hizmetler" className="hover:text-gold-light transition-colors">Optimizasyon</a></li>
            </ul>
          </div>

          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">İletişim</p>
            <div className="mt-4 space-y-3 text-sm text-slate-400">
              <a
                href={getWhatsAppLink(whatsappNumber)}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackWhatsAppClick("footer")}
                className="flex items-center gap-2 hover:text-gold-light transition-colors"
                data-testid="footer-whatsapp-link"
              >
                <MessageCircle className="h-4 w-4" /> {formattedNumber}
              </a>
              <a
                href="https://instagram.com/contenthousetr"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 hover:text-gold-light transition-colors"
                data-testid="footer-instagram-link"
              >
                <Instagram className="h-4 w-4" /> @contenthousetr
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 border-t border-white/5 pt-6 text-center text-xs text-slate-500">
          © {new Date().getFullYear()} Content House TR — Meta Reklam Yöneticisi. Tüm hakları saklıdır.
        </div>
      </div>
    </footer>
  );
}
